import { Pipe, PipeTransform } from '@angular/core';
import { SegmentoProduto } from 'src/app/core/models/provedor/SegmentoProduto';

@Pipe({
  name: 'segmentoProduto',
})
export class SegmentoProdutoPipe implements PipeTransform {
  transform(segmentoProduto: SegmentoProduto): string {
    const labels = {
      [SegmentoProduto.Saude]: 'Saúde',
      [SegmentoProduto.Odontologico]: 'Odonto',
      [SegmentoProduto.Vida]: 'Vida',
      [SegmentoProduto.ValeAlimentacao]: 'Vale Alimentação',
      [SegmentoProduto.ValeRefeicao]: 'Vale Refeição',
    };

    return labels[segmentoProduto];
  }
}
